// extracted by mini-css-extract-plugin
module.exports = {"root":"FilterHeader_root__8Lea8","centered":"FilterHeader_centered__OuoJJ","centerSlot":"FilterHeader_centerSlot__v9CmN"};